"use client";

import { useEffect } from "react";
import { initOpenAiAdsPixel } from "./track";
import type { OpenAiAdsApp } from "./pixel-ids";

export const OpenAiAdsInit = ({ app }: { app: OpenAiAdsApp }) => {
  useEffect(() => {
    initOpenAiAdsPixel(app);
  }, [app]);

  return null;
};
